module.exports = __webpack_public_path__ + "static/media/calendar_today.a08eb1e3.svg";